import gsap from "../gsap";

const slideToCurrent = (currentSlide) => {
  gsap.to(".content", {
    duration: 0,
    scrollTo: { x: currentSlide, offsetX: 15 },
    overwrite: "auto",
  });
};

const init = () => {
  "use strict";
  const menuPanels = document.querySelectorAll(".menu-panel");

  if (menuPanels.length) {
    menuPanels.forEach(function (panel) {
      panel.addEventListener("click", function (el) {
        const table = panel.querySelectorAll(".table-of-contents")[0];

        menuPanels.forEach(function (el) {
          el.classList.remove("active");
        });

        table.scrollTop = 0;
        panel.classList.add("active");
      });
    });
  }
};

export default init;

export const handleScrollTo = (paragraphID, callback) => {
  const paragraphElement = document.getElementById(paragraphID);

  slideToCurrent(paragraphElement);
  callback(paragraphElement.id);
};
